<template>
  <div class="evaluation-table">
    <div class="evaluation-table__header">
      <h3 class="evaluation-table__title" v-if="title">{{ title }}</h3>
      <h4 class="evaluation-table__description" v-if="description">{{ description }}</h4>
    </div>
    <div class="evaluation-table__body" :style="{padding: noContentPadding ? '0' : 'var(--attendee-gap-md)'}">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.evaluation-table {
  overflow: hidden;
  border-radius: var(--attendee-card-border-radius);
  border: 1px solid var(--attendee-border-color);
  margin-bottom: var(--attendee-gap-lg);

  &__header {
    padding: var(--attendee-gap-md);
    background-color: rgb(88 88 88 / 5%);
  }

  &__title {
    color: var(--attendee-text-primary-color);
    font-size: 16px;
    font-weight: 600;
    margin-bottom: var(--attendee-gap-sm);
  }

  &__description {
    color: var(--attendee-text-primary-color);
    font-size: 14px;
    font-weight: 400;
  }

  &__body {
    //padding: var(--attendee-gap-md);
  }
}
</style>


<script>
export default {
  props: ['title', 'description', 'noContentPadding']
}
</script>